export const JWT_TOKEN_NAME = 'accessToken';